import React from 'react';

function DriveInfoItemMenuPanel({ onEdit, onDelete, onCancel, style }) {
  return (
    <div style={{
      background: '#fff',
      borderRadius: 12,
      padding: 12,
      minWidth: 160,
      boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
      position: 'absolute',
      zIndex: 12000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 8,
      ...style
    }}>
      <button
        onClick={onEdit}
        style={{
          padding: '8px 0',
          fontSize: '1.05rem',
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid #6cf',
          background: '#eaf6ff',
          color: '#227',
          cursor: 'pointer',
          transition: 'background 0.2s'
        }}
      >Edytuj</button>
      <button
        onClick={onDelete}
        style={{
          padding: '8px 0',
          fontSize: '1.05rem',
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid #f66',
          background: '#fff0f0',
          color: '#a22',
          cursor: 'pointer',
          transition: 'background 0.2s'
        }}
      >Usuń</button>
      <button
        onClick={onCancel}
        style={{
          padding: '8px 0',
          fontSize: '1.05rem',
          fontWeight: 600,
          borderRadius: 8,
          border: '1px solid #bbb',
          background: '#f8f8f8',
          color: '#555',
          cursor: 'pointer',
          transition: 'background 0.2s'
        }}
      >Anuluj</button>
    </div>
  );
}

export default DriveInfoItemMenuPanel;
